import rich from './xAxis.nameTextStyle.rich'

export default {
  name: "nameTextStyle",
  nickname: "名称文字样式",
  desc: "坐标轴名称的文字样式。",
  type: "object",
  props: {
    color: {
      name: "color",
      nickname: "颜色",
      desc:
        '坐标轴名称的颜色，默认取 <a target="__blank" href="https://echarts.apache.org/zh/option.html#xAxis.axisLine.lineStyle.color">axisLine.lineStyle.color</a>。',
      eType: "color",
    },
    fontStyle: {
      name: "fontStyle",
      nickname: "字体样式",
      desc: "坐标轴名称文字字体的风格",
      value: "normal",
      defaultValue: "normal",
      type: "pureValue",
    },
    fontWeight: {
      name: "fontWeight",
      nickname: "字体粗细",
      desc: "坐标轴名称文字字体的粗细",
      value: "normal",
      defaultValue: "normal",
      type: "pureValue",
    },
    fontFamily: {
      name: "fontFamily",
      nickname: "字体",
      desc: "坐标轴名称文字的字体系列",
      value: "sans-serif",
      defaultValue: "sans-serif",
      type: "pureValue",
    },
    fontSize: {
      name: "fontSize",
      nickname: "字体大小",
      desc: "坐标轴名称文字的字体大小",
      value: 12,
      defaultValue: 12,
      type: "pureValue",
    },
    align: {
      name: "align",
      nickname: "对齐",
      desc: "文字水平对齐方式，默认自动。",
    },
    verticalAlign: {
      name: "verticalAlign",
      nickname: "垂直对齐",
      desc: "文字垂直对齐方式，默认自动。",
    },
    lineHeight: {
      name: "lineHeight",
      nickname: "行高",
      desc: "行高。",
    },
    backgroundColor: {
      name: "backgroundColor",
      nickname: "背景色",
      desc: "文字块背景色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc: "文字块边框颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc: "文字块边框宽度。",
      value: 0,
      defaultValue: 0,
    },
    borderRadius: {
      name: "borderRadius",
      nickname: "边框圆角",
      desc: "文字块的圆角。",
      value: 0,
      defaultValue: 0,
    },
    padding: {
      name: "padding",
      nickname: "内边距",
      desc: "文字块的内边距。例如：",
      value: 0,
      defaultValue: 0,
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: "文字块的背景阴影颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc: "文字块的背景阴影长度。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "文字块的背景阴影 X 偏移。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "文字块的背景阴影 Y 偏移。",
      value: 0,
      defaultValue: 0,
    },
    width: {
      name: "width",
      nickname: "宽度",
      desc:
        '文字块的宽度。一般不用指定，不指定则自动是文字的宽度。在想做表格项或者使用图片（参见 <code class="codespan">backgroundColor</code>）时，可能会使用它。',
    },
    height: {
      name: "height",
      nickname: "高度",
      desc:
        '文字块的高度。一般不用指定，不指定则自动是文字的高度。在使用图片（参见 <code class="codespan">backgroundColor</code>）时，可能会使用它。',
    },
    textBorderColor: {
      name: "textBorderColor",
      nickname: "文本边框颜色",
      desc: "文字本身的描边颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    textBorderWidth: {
      name: "textBorderWidth",
      nickname: "文本边框宽度",
      desc: "文字本身的描边宽度。",
      value: 0,
      defaultValue: 0,
    },
    textShadowColor: {
      name: "textShadowColor",
      nickname: "文本阴影宽度",
      desc: "文字本身的阴影颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    textShadowBlur: {
      name: "textShadowBlur",
      nickname: "文本阴影长度",
      desc: "文字本身的阴影长度。",
      value: 0,
      defaultValue: 0,
    },
    textShadowOffsetX: {
      name: "textShadowOffsetX",
      nickname: "文本阴影X偏移",
      desc: "文字本身的阴影 X 偏移。",
      value: 0,
      defaultValue: 0,
    },
    textShadowOffsetY: {
      name: "textShadowOffsetY",
      nickname: "文本阴影Y偏移",
      desc: "文字本身的阴影 Y 偏移。",
      value: 0,
      defaultValue: 0,
    },
    rich,
  },
}
